<template>
    <b-modal id="saveStaffDataModal" centered modal-class="modal-garden-help" title="Staff Info"
        header-class="px-lg-5 px-md-3 px-1 pb-0 mt-2" body-class="px-lg-5  px-4" title-class="modal-title-garden-help"
        footer-class=" justify-content-center mt-1 px-lg-5  px-4" @show="beforeShowModal($event)"
        no-close-on-backdrop no-close-on-esc>
        <div class="d-block mb-2">
            <input id="client" name="client" type="hidden" v-model="client_name" />
            <!-- {{ client_name }}, {{ company_id }}, {{ type }} -->
            <!-- {{ staff_obj.invalid_first_name }},{{ staff_obj.country_code }} -->
            <b-overlay :show="show_overlay" variant="success" :opacity=".5" rounded="sm" style="min-height:100%">
                <StaffDataComponent :type="type" :first_name.sync="staff_obj.first_name"
                    :invalid_first_name="staff_obj.invalid_first_name" :last_name.sync="staff_obj.last_name"
                    :invalid_last_name="staff_obj.invalid_last_name" :email.sync="staff_obj.email"
                    :invalid_email="staff_obj.invalid_email" :invalid_correct_email="staff_obj.invalid_correct_email"
                    :phone_number.sync="staff_obj.phone" :invalid_phone_number="staff_obj.invalid_phone"
                    :experience_level.sync="staff_obj.experience_level"
                    :invalid_experience_level="staff_obj.invalid_experience_level" :service.sync="staff_obj.services"
                    :invalid_service="staff_obj.invalid_services" :address.sync="staff_obj.address"
                    :longitude.sync="staff_obj.longitude" :latitude.sync="staff_obj.latitude"
                    :invalid_address="staff_obj.invalid_address"
                    :invalid_address_longitude="staff_obj.invalid_address_longitude"
                    :invalid_address_latitude="staff_obj.invalid_address_latitude" :country.sync="staff_obj.country"
                    :county.sync="staff_obj.county" :city.sync="staff_obj.city" :country_code="staff_obj.country_code" />
            </b-overlay>

        </div>
        <!-- {{ first_name }}, {{ last_name }},{{ email }},{{ phone }}, {{ experience_level }}
        <hr />
        {{ service }}
        <hr />
        {{ address }}, {{ longitude }},{{ latitude }},
        {{ country }}, {{ county }}, {{ city }}, {{ country_code }} -->
        <!-- {{ staff_obj }} -->

        <template #modal-footer>
            <b-row class="justify-content-center w-100 m-0">
                <b-col xl="4" lg="5" cols="6" class="text-center">
                    <b-button type="button" variant="garden-help-primary" class="btn-bumblebee btn-garden-help mb-1 w-100"
                        v-if="!is_loading" @click="clickSave">
                        Save
                    </b-button>
                    <b-button type="button" disabled variant="garden-help-primary"
                        class="btn-bumblebee btn-garden-help  mb-1 w-100" v-else>
                        <b-spinner small label="Small Spinner" variant="light"></b-spinner>
                        Loading
                    </b-button>
                </b-col>
                <b-col xl="4" lg="5" cols="6" class="text-center">
                    <b-button type="button" variant="garden-help-danger-outline"
                        class="btn-bumblebee btn-garden-help mb-1 w-100" @click="closeModalCancel">
                        Cancel
                    </b-button>
                </b-col>


            </b-row>
        </template>
    </b-modal>
</template>
<script>
import $ from "jquery";
import axios from "axios";
import StaffDataComponent from "../profile_details_components/StaffDataComponent.vue";
import { validatePassword, validateEmail } from "@/utils/validate.js";
import countries_list from '@/assets/country-list-data.json'

export default {
    name: "StaffInfoModal",
    components: { StaffDataComponent },
    props: ["client_name", "company_id", "type", "staff_obj_prop"],
    data() {
        return {
            is_loading: false,
            show_overlay: false,

            staff_obj: {
                first_name: "",
                invalid_first_name: false,
                last_name: "",
                invalid_last_name: false,
                email: "",
                invalid_email: false,
                invalid_correct_email: false,
                phone: "",
                invalid_phone: false,
                experience_level: "",
                invalid_experience_level: false,
                services: null,
                invalid_services: false,

                address: null,
                longitude: null,
                latitude: null,
                invalid_address: false,
                invalid_address_longitude: false,
                invalid_address_latitude: false,
                country: null,
                county: null,
                city: null,
                country_code: null
            }
        };
    },

    mounted() {
    },

    methods: {
        validateEmail,
        closeModalCancel() {
            this.$bvModal.hide("saveStaffDataModal");
        },
        clickSave() {
            console.log("in save/add staff ", this.client_name, this.company_id);
            this.is_loading = true

            this.checkValidation()
            console.log(this.staff_obj.invalid_first_name, this.staff_obj.invalid_last_name,
                this.staff_obj.invalid_email, this.staff_obj.invalid_correct_email,
                this.staff_obj.invalid_phone, this.staff_obj.invalid_experience_level,
                this.staff_obj.invalid_services, this.staff_obj.invalid_address, this.staff_obj.invalid_address_longitude,
                this.staff_obj.invalid_address_latitude)

            if (!this.staff_obj.invalid_first_name && !this.staff_obj.invalid_last_name &&
                !this.staff_obj.invalid_email && !this.staff_obj.invalid_correct_email &&
                !this.staff_obj.invalid_phone && !this.staff_obj.invalid_experience_level &&
                !this.staff_obj.invalid_services && !this.staff_obj.invalid_address &&
                !this.staff_obj.invalid_address_latitude && !this.staff_obj.invalid_address_longitude) {
                if (this.type === 'add') {

                    this.sendAddStaffRequest()

                    // this.$fire({
                    //     text: "Staff created successfully",
                    //     type: "success",
                    //     customClass: {
                    //         container: "swal-alert-garden-help",
                    //         confirmButton:
                    //             "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
                    //         cancelButton:
                    //             "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
                    //     },

                    // }).then((r) => {
                    //     this.$bvModal.hide("saveStaffDataModal");
                    //     console.log(this.$parent)
                    //     // this.$parent.getJobDetails()
                    //     this.is_loading = false
                    // });
                }
                else if (this.type === 'edit') {
                    this.sendEditStaffRequest()
                    // this.$fire({
                    //     text: "Staff updated successfully",
                    //     type: "success",
                    //     customClass: {
                    //         container: "swal-alert-garden-help",
                    //         confirmButton:
                    //             "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
                    //         cancelButton:
                    //             "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
                    //     },

                    // }).then((r) => {
                    //     this.$bvModal.hide("saveStaffDataModal");
                    //     console.log(this.$parent)
                    //     // this.$parent.getJobDetails()
                    //     this.is_loading = false
                    // });
                }
            } else {
                this.is_loading = false
            }

        },
        checkValidation() {
            console.log("check validation")
            if (this.staff_obj.first_name == null || this.staff_obj.first_name == "") {
                this.staff_obj.invalid_first_name = true;
            } else {
                this.staff_obj.invalid_first_name = false;
            }
            if (this.staff_obj.last_name == null || this.staff_obj.last_name == "") {
                this.staff_obj.invalid_last_name = true;
            } else {
                this.staff_obj.invalid_last_name = false;
            }
            if (this.staff_obj.email == null || this.staff_obj.email == "") {
                this.staff_obj.invalid_email = true;
            } else {
                this.staff_obj.invalid_email = false;
                if (this.validateEmail(this.staff_obj.email)) {
                    this.staff_obj.invalid_correct_email = false;
                } else {
                    this.staff_obj.invalid_correct_email = true;
                }
            }
            if (this.staff_obj.phone == null || this.staff_obj.phone == "") {
                this.staff_obj.invalid_phone = true;
            } else {
                this.staff_obj.invalid_phone = false;
            }
            if (this.staff_obj.services == null || this.staff_obj.services == "") {
                this.staff_obj.invalid_services = true;
            } else {
                this.staff_obj.invalid_services = false;
            }
            if (this.staff_obj.experience_level == null || this.staff_obj.experience_level == "") {
                this.staff_obj.invalid_experience_level = true;
            } else {
                this.staff_obj.invalid_experience_level = false;
            }


            console.log("address")
            console.log(this.staff_obj.address)
            if (this.staff_obj.address == null || this.staff_obj.address == '') {
                this.staff_obj.invalid_address = true
            } else {
                this.staff_obj.invalid_address = false
                if (this.staff_obj.latitude == null || this.staff_obj.latitude == '') {
                    this.staff_obj.invalid_address_latitude = true
                } else {
                    this.staff_obj.invalid_address_latitude = false
                }
                if (this.staff_obj.longitude == null || this.staff_obj.longitude == '') {
                    this.staff_obj.invalid_address_longitude = true
                } else {
                    this.staff_obj.invalid_address_longitude = false
                }
            }
        },

        sendAddStaffRequest() {
            console.log("in send add staff request")
            console.log(this.company_id)
            console.log(this.staff_obj)

            let requestData = {
                client: this.client_name,

                "contractor_company_id": this.company_id,
                "staff_accounts": [this.staff_obj]
            }
            console.log(requestData)

            axios
                .post(
                    "/operator/contractor/register-staff",
                    requestData,
                    {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            client: this.client_name,
                            Authorization:
                                "Bearer " +
                                JSON.parse(window.localStorage.getItem("user")).access_token,
                        },
                    }
                )
                .then((response) => {
                    console.log(response);
                    this.is_loading = false;
                    this.$fire({
                        text: response.data.success,
                        type: "success",
                        customClass: {
                            container: "swal-alert-garden-help",
                            confirmButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
                            cancelButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
                        },

                    }).then((r) => {
                        this.$bvModal.hide("saveStaffDataModal");
                        this.$parent.getStaffList()
                    });
                })
                .catch((error) => {
                    console.log(error);
                    this.is_loading = false;

                    this.$fire({
                        // title: "Title",
                        text: error.response.data.error,
                        type: "error",
                        customClass: {
                            container: "swal-alert-garden-help",
                            confirmButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
                            cancelButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
                        },
                        // timer: 5000,
                    }).then((r) => {
                    });

                });

        },
        sendEditStaffRequest() {
            console.log("in send edit staff request")
            console.log(this.company_id)
            console.log(this.staff_obj)

            let requestData = this.staff_obj
            requestData.client = this.client_name,
                console.log(requestData)


            axios
                .post(
                    "/operator/contractor/update-staff",
                    requestData,
                    {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            client: this.client_name,
                            Authorization:
                                "Bearer " +
                                JSON.parse(window.localStorage.getItem("user")).access_token,
                        },
                    }
                )
                .then((response) => {
                    console.log(response);
                    this.is_loading = false;
                    this.$fire({
                        text: "Staff updated successfully",
                        type: "success",
                        customClass: {
                            container: "swal-alert-garden-help",
                            confirmButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
                            cancelButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
                        },

                    }).then((r) => {
                        this.$bvModal.hide("saveStaffDataModal");
                        this.$parent.getStaffList()
                    });
                })
                .catch((error) => {
                    console.log(error);
                    this.is_loading = false;

                    this.$fire({
                        // title: "Title",
                        text: error.response.data.error,
                        type: "error",
                        customClass: {
                            container: "swal-alert-garden-help",
                            confirmButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
                            cancelButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
                        },
                        // timer: 5000,
                    }).then((r) => {
                    });

                });

        },

        beforeShowModal(e) {
            // alert(this.type)
            this.show_overlay = this.type == 'edit' ? true : false
            console.log(e)
            // e.preventDefault()
            let user = JSON.parse(window.localStorage.getItem("user"));
            this.staff_obj.country = user.country
            const country_data = countries_list.find(({ country }) => country === user.country);
            console.log(country_data)
            this.staff_obj.country_code = country_data.country_code


            if (this.type === 'add') {
                this.staff_obj.first_name = null
                this.staff_obj.invalid_first_name = false
                this.staff_obj.last_name = null
                this.staff_obj.invalid_last_name = false
                this.staff_obj.email = null
                this.staff_obj.invalid_email = false
                this.staff_obj.invalid_correct_email = false
                this.staff_obj.phone = null
                this.staff_obj.invalid_phone = false
                this.staff_obj.experience_level = ''
                this.staff_obj.invalid_experience_level = false
                this.staff_obj.services = null
                this.staff_obj.invalid_services = false
                this.staff_obj.address = null
                this.staff_obj.longitude = null
                this.staff_obj.latitude = null
                this.staff_obj.invalid_address = false
                this.staff_obj.invalid_address_longitude = false
                this.staff_obj.invalid_address_latitude = false
                this.staff_obj.county = null
                this.staff_obj.city = null
                this.staff_obj.country = user.country
                this.staff_obj.country_code = country_data.country_code
            } else if (this.type === 'edit' && this.staff_obj_prop) {
                console.log(this.staff_obj_prop)
                this.staff_obj = this.staff_obj_prop
                this.staff_obj.country = user.country
                this.staff_obj.country_code = country_data.country_code

                this.staff_obj.phone = this.staff_obj_prop.phone // '+441234567899'
                this.staff_obj.services = this.staff_obj_prop.services.map(item => item.id);

                console.log(this.staff_obj_prop.services)
                console.log(this.staff_obj_prop.services.map(item => item.id))

                this.staff_obj.invalid_first_name = false
                this.staff_obj.invalid_last_name = false
                this.staff_obj.invalid_email = false
                this.staff_obj.invalid_correct_email = false
                this.staff_obj.invalid_phone = false
                this.staff_obj.invalid_experience_level = false
                this.staff_obj.invalid_services = false
                this.staff_obj.invalid_address = false
                this.staff_obj.invalid_address_longitude = false
                this.staff_obj.invalid_address_latitude = false

                setTimeout(() => {
                    this.show_overlay = false
                }, "2000");

            }
            this.$bvModal.show("saveStaffDataModal");

        }
    },
};
</script>
      


// WEBPACK FOOTER //
// src/projects/garden_help/contractor/modals/StaffInfoModal.vue